//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: ['website'],
    data: function data() {
        return {
            days: [{
                day: '',
                open: '',
                close: '',
                opened: true
            }]
        };
    },

    methods: {
        deploySite: function deploySite() {
            Event.$emit('deploy-site');
        },
        changeDayStatus: function changeDayStatus(idx, val) {
            console.log('changeDayStatus - idx = ' + idx + ' val = ' + val);
            this.$set(this.days[idx], 'opened', val);
        },
        addHours: function addHours(idx) {
            this.days.splice(idx + 1, 0, {
                day: '',
                open: '',
                close: '',
                opened: true
            });
        },
        removeHours: function removeHours(idx) {
            this.days.splice(idx, 1);
        },
        savePageContact: function savePageContact() {
            var _this = this;

            var $el = this;
            var data = {};
            data.id = $el.website.id;
            data.days = $el.days;
            data.phone = this.website.phone;
            data.email = this.website.email;
            axios.post('/prototype/website/' + $el.website.id, data).then(function (response) {
                if (response.data.error) {
                    _this.$snotify.error('Error saving contact data: ' + response.data.error);
                } else {
                    _this.$snotify.success('Website contact data was updated');
                    Event.$emit('refresh-property-website', $el.website.property_id);
                }
            });
        }
    },
    watch: {
        website: { // watch it
            immediate: true,
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal && newVal.hours && newVal.hours.length) {
                    this.days = JSON.parse(newVal.hours);
                }
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/Contact.vue
// module id = g38y
// module chunks = 0 1